'use client';

import React from 'react';
import { useForm } from 'react-hook-form';
import useDebounceCallback from '../../hooks/useDebounceCallback';
import { constructClassName } from '../../utils/constructClassName';
import styles from './styles.module.scss';
import { AppTextInput } from '../formFields';
import { Icon } from '../Icon';
import colors from '../../styles/colors/index.module.scss';

interface Props {
  containerClassName?: string;
  placeholder?: string;
  onChange?: (value: string) => void;
  initialValue?: string;
}

export const SearchInput: React.FC<Props> = ({
  containerClassName,
  placeholder,
  onChange,
  initialValue,
}) => {
  const { control } = useForm();

  const handleInputChange = useDebounceCallback((value: string) => {
    if (onChange) {
      onChange(value);
    }
  }, 300);

  return (
    <div className={constructClassName([containerClassName, styles.container])}>
      <AppTextInput
        name="search"
        control={control}
        classNames={{
          input: styles.inputContainer,
        }}
        type="text"
        placeholder={placeholder || 'Search...'}
        onChange={(value) => {
          if (typeof value === 'string') {
            handleInputChange(value);
          }
        }}
        defaultValue={initialValue}
      />
      <Icon
        icon="magnifyingGlassClassicRegular"
        className={styles.icon}
        fill={colors.secondary}
      />
    </div>
  );
};
